import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionFigmaWork = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"type": "page",
			"properties": {
				"title": [
					[
						"Работа"
					]
				]
			},
			"content": [
				"84034bb7-9390-490b-bea7-e09c7d852c89",
				"60a468c8-2b6f-4df3-a715-7b3d91300594",
				"c76ee7c8-3d2c-41e3-8c95-11d4e6b7d8ac",
				"f4aac8fb-6df3-4995-9f2a-2786a8301708",
				"9506fceb-8cdf-47c5-9c89-7059c253c871",
				"ccbf115a-6aab-4171-a50c-a21772ab0e5e",
				"dcf37d2a-dbd4-4a94-9973-7a837f733b72",
				"eb3e92ab-02d6-4f8c-9777-1f220d99c624",
				"612f8cbf-5d9f-4fd7-b77e-c9dd573c3c2b",
				"315bdd77-cafa-445f-85a8-85639608f144",
				"19699d63-a073-4287-abf0-c34afabd41a8",
				"95a52597-1a02-491e-8f1a-e9e4e06f8fe6",
				"2728b500-40f9-4b43-8dbf-d4a9357227b7",
				"fe89f411-ce2f-4297-8c27-f82efe8c1bb4",
				"f3b962e3-1ff8-49c4-bffe-66aaa65fb415",
				"2dbe7a31-413e-43dd-8754-39261752ddf7",
				"0a575fc0-1a41-47c9-b619-4e4134f7678d",
				"9fb19081-1388-4ba2-90a3-d1988a6254a4",
				"ae5b97f1-5818-4207-bc77-8d49f15bd7c8",
				"e37ebbd2-e953-49ff-9b76-b1e59ad90d92",
				"a15fdf91-b2de-4d41-b74a-b5d4e28b0470",
				"52b75129-1c2f-42e6-8861-1380053de8d0",
				"347e796e-ea32-47b9-8b2a-28f95a6f51db",
				"6ba3a5aa-f5da-439e-b57f-3b622cf02267",
				"f3aa0e5c-d014-4c33-bbf1-314e22929fda",
				"609dd063-7801-43de-a8b4-2b3720323b4a",
				"0c3388b7-c33e-476e-b4ae-9f3afa89f044",
				"fee305ba-9c02-4516-bf75-af4ee40a1cd1",
				"03a2b9de-9eea-49dd-93a2-ec887e12b0cd",
				"ff114400-d84e-445c-bab4-4e02fa1608e2",
				"f548a9f3-a474-4615-a726-93d76c109e0a",
				"518fb664-05ed-46dc-8bc7-11a5fc46a06e",
				"6812602a-c4bb-4cc9-8daf-c454c90a5541",
				"70b61101-9e2b-49c1-be48-0fc8312105bd",
				"d1c4914c-f996-41bc-899d-758da11a41aa",
				"38832903-9449-4a81-ac50-fa48b0863560",
				"9a60f293-16ee-4b3a-a007-361bab2cc35e",
				"6050453f-0377-42ff-b20a-07c9630d1153"
			],
			"format": {
				"copied_from_pointer": {
					"id": "63575aa4-115a-4d0e-9d15-cafab8e22ce9",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"page_cover_position": 0.6
			},
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"file_ids": [
				"67a11250-3902-42bf-9270-92a142a7a6dc"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "84034bb7-9390-490b-bea7-e09c7d852c89",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/figma/work\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f9ca8df1-21ba-4e1e-8ff1-a6f63d577ea4",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "60a468c8-2b6f-4df3-a715-7b3d91300594",
			"type": "text",
			"properties": {
				"title": [
					[
						"Раньше дизайнеры работали и хранили дизайн-документацию изолировано друг от друга. Такой подход приводил к несогласованным действиям: дизайнеры решали схожие задачи одновременно в отрыве друг от друга. Мы считаем, что объединение файлов и дизайн-документации в одном пространстве должно решить эти проблемы. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d6999a82-ed22-4fb3-8313-ddce4ec9181c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c76ee7c8-3d2c-41e3-8c95-11d4e6b7d8ac",
			"type": "header",
			"properties": {
				"title": [
					[
						"Процесс работы над проектом"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "38af7236-4cb8-4652-bab9-bd66a4b1f939",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f4aac8fb-6df3-4995-9f2a-2786a8301708",
			"type": "text",
			"properties": {
				"title": [
					[
						"Чтобы поддерживать дизайн-документацию в системе, важно соблюдать базовый процесс дизайна продуктов."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "c3ea6402-bd2b-4e27-b4ec-ac6aeedcca4a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9506fceb-8cdf-47c5-9c89-7059c253c871",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"1. Получение задачи"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b580d58c-cf09-4320-9eb8-43e69f1f9c18",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ccbf115a-6aab-4171-a50c-a21772ab0e5e",
			"type": "text",
			"properties": {
				"title": [
					[
						"При постановке задачи менеджер или автор заполняет в Jira специально подготовленный шаблон. В нем он указывает цели и метрики на которые влияет задача, платформу для которой нужны макеты, краткое описание фичи и желаемые сроки."
					]
				]
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "dcf37d2a-dbd4-4a94-9973-7a837f733b72",
			"type": "text",
			"properties": {
				"title": [
					[
						"После того как менеджер поставил вам задачу, создайте файл в вашем проекте Figma. Имя файла должно состоять из номера задачи в Jira и краткого описания фичи. Например, SP-13456_Settings_main_menu."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1fe421e2-1885-41c8-86cc-cd18bccc3f28",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "eb3e92ab-02d6-4f8c-9777-1f220d99c624",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Используйте латинские символы, чтобы ссылка была понятная и короткая"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d03411c8-9c62-4717-b611-b66af776448d",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "612f8cbf-5d9f-4fd7-b77e-c9dd573c3c2b",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Не придумывайте слишком длинные названия, чтобы файл было легче найти и отсортировать"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "240c8e1d-68b5-40f3-9b5b-857608cb4600",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "315bdd77-cafa-445f-85a8-85639608f144",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"2. Работа над дизайном"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "fefb72c5-585f-4a74-94dd-677f897353c1",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "19699d63-a073-4287-abf0-c34afabd41a8",
			"type": "text",
			"properties": {
				"title": [
					[
						"Когда работаете над макетами, придерживайтесь нашей системы наименования страниц в одном файле."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "110294bc-6d8d-4d8d-8ffa-70d7d52fe94d",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "95a52597-1a02-491e-8f1a-e9e4e06f8fe6",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Release. ",
						[
							[
								"b"
							]
						]
					],
					[
						"Последние версии макетов, которые переданы в разработку. Важно поддерживать эти макеты в актуальном состоянии, поскольку тестировщики проверяют реализацию именно по ним."
					],
					[
						" На странице есть статусы проверки текстов, ссылка на переводы от редакции. Так же на этой странице должны находится макеты разметки интерфейса для скринридера, или ссылка на них.",
						[
							[
								"h",
								"default"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1987a392-bbd1-416f-a3af-803d7791a8af",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2728b500-40f9-4b43-8dbf-d4a9357227b7",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Work in progress. ",
						[
							[
								"b"
							]
						]
					],
					[
						"На этой странице ведется основная работа, проводятся эксперименты."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "4c65455b-8d5e-423e-ba0c-7feca2097de9",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fe89f411-ce2f-4297-8c27-f82efe8c1bb4",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Archive/Draft. ",
						[
							[
								"b"
							]
						]
					],
					[
						"Архив макетов, которые были нарисованы в процессе работы и которые могут пригодиться в будущем."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "02503968-d792-426f-aca0-01cb482c269b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f3b962e3-1ff8-49c4-bffe-66aaa65fb415",
			"type": "text",
			"properties": {
				"title": [
					[
						"Также можно создавать отдельные страницы для прототипов. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "02b78609-6d6a-4c87-982f-02714d4d3dbd",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2dbe7a31-413e-43dd-8754-39261752ddf7",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Эти советы — только рекомендация. Не забывайте, что один из принципов нашей работы — автономность. Мы понимаем, что правила могут не подходить для всех случаев."
					]
				]
			},
			"format": {
				"page_icon": "💡",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "575d2b20-c24b-4eef-abc9-c6062c143d9a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0a575fc0-1a41-47c9-b619-4e4134f7678d",
			"type": "text",
			"properties": {
				"title": [
					[
						"Макеты делаются согласно дизайн–системе вашего продукта. При работе с текстами в макетах подключается редакция. Важно чтобы перед исследование прототипом тексты были финальными."
					]
				]
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9fb19081-1388-4ba2-90a3-d1988a6254a4",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"3. Обновления в мастер-файле"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "52fabe8f-29f9-4464-8f64-0d63d5019a5c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ae5b97f1-5818-4207-bc77-8d49f15bd7c8",
			"type": "text",
			"properties": {
				"title": [
					[
						"Мы рекомендуем создать отдельный проект для хранения мастер-файлов. Мастер-файл содержит реализованные разработкой страницы или наборы компонентов и должен быть отделен от ваших исследований и набросков."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5906761d-7d1c-4130-90bc-55ef3b495ac8",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e37ebbd2-e953-49ff-9b76-b1e59ad90d92",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Это упростит доступ к решениям и шаблонам внутри продукта"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f4bf58b6-2695-4e12-b282-075f64fbad4c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a15fdf91-b2de-4d41-b74a-b5d4e28b0470",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Это поможет синхронизироваться с другими разработанными функциями"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "13959880-c12a-41b7-949a-5e9779d378f3",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "52b75129-1c2f-42e6-8861-1380053de8d0",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Коллеги всегда будут знать, где найти актуальную информацию"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3a7c20be-16d8-4408-8ccd-9ef88a72c67f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "347e796e-ea32-47b9-8b2a-28f95a6f51db",
			"type": "text",
			"properties": {
				"title": [
					[
						"Это может показаться избыточным и трудоемким, но на самом деле скопировать макеты со страницы Release и добавить их в другой файл — очень просто."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "6137015a-98ec-4d81-9a5e-1d47970c1ecd",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6ba3a5aa-f5da-439e-b57f-3b622cf02267",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Старайтесь не использовать одинаковые тексты или «рыбу» в своих макетах. Помните, что любой макет могут взять для маркетинговых целей. Идеальный макет рисуют с использованием реальных данных, картинок и текстов."
					]
				]
			},
			"format": {
				"page_icon": "💡",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "f7550180-167a-4610-8ddc-d0a89152eb98",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f3aa0e5c-d014-4c33-bbf1-314e22929fda",
			"type": "image",
			"properties": {
				"size": [
					[
						"197.0KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/23790c0e-351e-4fda-b85d-8e672e4a5361/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/23790c0e-351e-4fda-b85d-8e672e4a5361/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5533333333333333,
				"block_preserve_scale": true
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"file_ids": [
				"23790c0e-351e-4fda-b85d-8e672e4a5361"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/f3aa0e5c-d014-4c33-bbf1-314e22929fda.png"
		},
		{
			"id": "609dd063-7801-43de-a8b4-2b3720323b4a",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"4. Передать макеты в разработку"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "eb61e5da-d0b7-4e22-b43c-592977e18b32",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0c3388b7-c33e-476e-b4ae-9f3afa89f044",
			"type": "text",
			"properties": {
				"title": [
					[
						"Чтобы передать готовый макет, скопируйте ссылку, отправьте менеджеру и добавьте комментарием к задаче Jira. Можно сделать это в самом начале, чтобы коллеги могли следить за ходом работы."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "ee7efde9-aa3f-4e5e-b7d6-3f1ac485c270",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fee305ba-9c02-4516-bf75-af4ee40a1cd1",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Убедитесь что вы дали ссылку на правильный фрейм и страницу"
					]
				]
			},
			"format": {
				"page_icon": "💡",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "6ba3a5aa-f5da-439e-b57f-3b622cf02267",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "03a2b9de-9eea-49dd-93a2-ec887e12b0cd",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"5. Поддержка разработки"
					]
				]
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ff114400-d84e-445c-bab4-4e02fa1608e2",
			"type": "text",
			"properties": {
				"title": [
					[
						"После передачи макета работа не заканчивается. Закладывайте в расписание время на поддержку. У разработчика могут возникнуть вопросы, и потребуется доработка макетов."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "7d299360-8a94-4b6b-afcd-db5486b7a783",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f548a9f3-a474-4615-a726-93d76c109e0a",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Проверяйте, что реализованные функции соответствуют макетам. При постановке задач не забывайте про этап дизайн-ревью."
					]
				]
			},
			"format": {
				"page_icon": "💡",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "473c94c9-e9e5-4228-95fe-447c89520fcf",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "518fb664-05ed-46dc-8bc7-11a5fc46a06e",
			"type": "header",
			"properties": {
				"title": [
					[
						"Создание локальных компонентов"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "7ca54604-44f9-4a9e-be07-606d28c0746f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6812602a-c4bb-4cc9-8daf-c454c90a5541",
			"type": "text",
			"properties": {
				"title": [
					[
						"Мы стремимся к тому, чтобы наши макеты состояли из компонентов на 100%. Если базовый набор компонентов Paradigm не покрывает ваши потребности, создайте локальные компоненты в своих проектах или локальных библиотеках."
					]
				]
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "70b61101-9e2b-49c1-be48-0fc8312105bd",
			"type": "text",
			"properties": {
				"title": [
					[
						"Компоненты внутри наших продуктов могут быть трех уровней."
					]
				]
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d1c4914c-f996-41bc-899d-758da11a41aa",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Базовые компоненты дизайн-системы. \nК ним относятся кнопки, модальные окна, снекбары. Все компоненты базовой библиотеки Paradigm. Разработкой и поддержкой компонентов занимается команда дизайн-системы. Изменения в эти компоненты вносятся по запросу к дизайнерам дизайн-системы или при создании задачи в Github. "
					]
				]
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "38832903-9449-4a81-ac50-fa48b0863560",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Локальные компоненты продукта.\nКомпоненты которы создаются специально для нужд продукта. Например ячейка списка писем или карточки новостей. Эти компоненты поддерживаются и разрабатываются командой продукта, команда дизайн-системы выступает в качестве консультантов. При этом мы рекомендуем чтобы все компоненты были покрыты стандартным набором токенов."
					]
				]
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9a60f293-16ee-4b3a-a007-361bab2cc35e",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Компоненты в файле.\nИногда возникают ситуации, когда ни локальный не базовый компонент не покрывают потребностей макета. Или нужно провести эксперимент в котором нужно создать дополнительный компонент. Мы рекомендуем создавать их на отдельной странице файла Figma. Такие компоненты помогут в будущем вносить изменения в макеты и могут вырасти в локальный компонент. "
					]
				]
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6050453f-0377-42ff-b20a-07c9630d1153",
			"type": "image",
			"properties": {
				"size": [
					[
						"69.4KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/dfc0aacf-ae75-45e7-9d8d-266fafcfddd3/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/dfc0aacf-ae75-45e7-9d8d-266fafcfddd3/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5088888888888888,
				"block_preserve_scale": true
			},
			"parent_id": "20802187-e25a-4d38-af64-a363ffcace1d",
			"parent_table": "block",
			"file_ids": [
				"dfc0aacf-ae75-45e7-9d8d-266fafcfddd3"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/6050453f-0377-42ff-b20a-07c9630d1153.png"
		}
	],
	"headers": [
		{
			"title": "Процесс работы над проектом",
			"id": "c76ee7c8-3d2c-41e3-8c95-11d4e6b7d8ac"
		},
		{
			"title": "Создание локальных компонентов",
			"id": "518fb664-05ed-46dc-8bc7-11a5fc46a06e"
		}
	]
}} />
);

export default NotionFigmaWork;
